export default function hiddenFields(fields: string[], when: boolean): void {
  fields.forEach((field) => {
    // idはinputを指しているため、inputを内包しているラッパー自体を非表示にする
    const element = document.getElementById(`field-${field}`);
    if (!element) return;
    if (when) {
      element.classList.add('is-hidden');
    } else {
      element.classList.remove('is-hidden');
    }
  });
}
